import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Autocomplete, Box, TextField, Typography} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {fetchCategories, selectCategories} from "../../store/categorySlice";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import {useTranslation} from "react-i18next";

const CategorySelect = ({
    selectedCategoryId,
    selectedCategoryIds,
    categoryType,
    excludeCategoryId,
    label,
    onChange,
    multiple = false,
    width = "75%",
    sx,
    error = false,
    helperText = null
}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const categories = useSelector(selectCategories);

    const [itemsList, setItemsList] = useState([]);
    const [inputText, setInputText] = useState("");
    const [expand, setExpand] = useState([]);
    const [expandAll, setExpandAll] = useState(false);


    const selectedCategory = categories ? categories.find(category => category.id === selectedCategoryId) || null : null;
    const selectedCategories = useMemo(() => {
        if (!multiple) return [];
        const ids = selectedCategoryIds || [];
        return (categories || []).filter((category) => ids.includes(category.id));
    }, [categories, multiple, selectedCategoryIds]);

    useEffect(() => {
        const typedCategories = categories.filter(category => category.type === categoryType)
        const categoryArray = [];
        sortCategories(null, categoryArray, typedCategories);
        setItemsList(categoryArray);
        setExpand([]);
    }, [categories, excludeCategoryId, categoryType]);

    useEffect(() => {
        dispatch(fetchCategories());
    }, [dispatch]);

    const sortCategories = (parent, resultArray, categories) => {
        // categories.forEach(child => {
        //     resultArray.push(child);
        // })
        const children = categories
            .filter(category => parent ? category.parentId === parent.id : !category.parentId)
            .filter(category => !excludeCategoryId || category.id !== excludeCategoryId)
            .map(child => {
                return {...child, level: (parent ? parent.level + 1 : 0)}
            });
        if (parent && children.length > 0) {
            parent.children = children;
        }
        children.forEach(child => {
            resultArray.push(child);
            sortCategories(child, resultArray, categories);
        })
    }

    const getRandomInt = (max) => {
        return Math.floor(Math.random() * max);
    }
    console.log("Rnder category slect")

    const filterOptions = useCallback((categories, { inputValue }) =>  {
        if(inputValue) {
            const result = []
            const cursor = {path: [], expand}
            categories.forEach(category => {
                if(cursor.expand != null && cursor.expand < category.level) {
                    result.push(category);
                } else {
                    if(category.level === 0 || (cursor.path.length > 0 && category.level < cursor.path[0].level )) {
                        cursor.path = [category]
                    } else if(cursor.path.length > 0 && category.level <= cursor.path[cursor.path.length - 1].level ){
                        cursor.path = cursor.path.slice(0, cursor.path.length - cursor.path[cursor.path.length - 1].level + category.level - 1)
                        cursor.path.push(category)
                    } else {
                        cursor.path.push(category)
                    }
                    if(category.name.toLowerCase().includes(inputValue.toLowerCase())) {
                        result.push(...cursor.path);
                        cursor.path = [];
                        cursor.expand = category.level;
                    } else {
                        cursor.expand = null;
                    }
                }
            });

            return result;
        } else {
            return categories.filter(category => !category.parentId || expand.includes(category.parentId))
        }
    }, [expand]); // ✅ Добавляем зависимости

    // ✅ Отдельный эффект для управления expandAll на основе inputText
    useEffect(() => {
        if (inputText) {
            setExpandAll(true);
        } else {
            setExpandAll(false);
        }
    }, [inputText]);

    const getAllParents = (categories, selected) => {
        const parentCategories = [];
        selected.forEach(category => {
            if(category.parentId) {
                const parent = categories.find(parent => parent.id ===category.parentId)
                parent && parentCategories.push(parent)
            }
        })
    }

    const handleExpandClick = useCallback((event, categoryId) => {
        event.stopPropagation();
        event.preventDefault();
        setExpand(prevExpand => {
            if (prevExpand.includes(categoryId)) {
                return prevExpand.filter(id => id !== categoryId);
            } else {
                return [...prevExpand, categoryId];
            }
        });
    }, []);

    // ✅ Исправленный обработчик для TextField
    const handleInputChange = useCallback((event) => {
        const value = event.target.value;
        setInputText(value || "");
    }, []);

    // ✅ Эффект для сброса expand при очистке input
    useEffect(() => {
        if (!inputText) {
            setExpand([]);
        }
    }, [inputText]);

    const handleCategorySelect = useCallback((event, newSelectedCategoryId) => {
        event.stopPropagation();
        event.preventDefault();
        onChange(newSelectedCategoryId);
    }, [onChange]);


    return (
        <Autocomplete
            multiple={multiple}
            sx={{...sx, display : 'inline-flex', width : width }}
            // className={
            //     listId && listId.length ? "autocomplete" : "autocomplete-empty"
            // }
            // disablePortal
            // clearOnEscape={false}
            onChange={(event, newSelectedCategory) =>
                handleCategorySelect(
                    event,
                    multiple
                        ? (newSelectedCategory || []).map((category) => category.id)
                        : (newSelectedCategory ? newSelectedCategory.id : null)
                )
            }
            options={itemsList}
            isOptionEqualToValue={(option, value) =>
                option?.id === value?.id
            }
            getOptionLabel={(category) => category.name}
            // disabled={disabled}
            value={multiple ? selectedCategories : selectedCategory}
            filterOptions={filterOptions}
            // onBlur={() => setInputText("")}
            // renderTags={() => renderChips()}
            // disableCloseOnSelect
            // inputValue={inputText}
            renderOption={(props, category) =>
                    <Box {...props} key={category.id}>
                        <Box onClick={(event) => handleExpandClick(event, category.id)}
                             sx={{
                                 width: (category.level + 1) * 25,
                                 textAlign: "right",
                                 mr: 1,
                                 position: "relative",

                             }}>{category.children && !expandAll && (expand.includes(category.id) ? <ExpandLess fontSize='small' sx={{mt: 1}}/>: <ExpandMore fontSize='small' sx={{mt: 1}}/>)}</Box>
                        <Typography variant='body1'>{category.name}</Typography>
                    </Box>}
            renderInput={(params) => (
                <TextField
                    {...params}
                    onChange={handleInputChange}
                    label={label ? label : t("common.labels.category")}
                    variant="standard" sx={{width: "100%"}}
                    error={!!error}
                    helperText={helperText}
                    fullWidth={false}
                    inputProps={{
                        ...params.inputProps,
                        id: "category" + getRandomInt(999999) + getRandomInt(999999),
                        autoComplete: "off", // disable autocomplete and autofill
                    }}
                />
            )}
        />
    );
};

export default CategorySelect;
